









import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import _ from "lodash";
import SimpleText from "front-component/components/SimpleText.vue";
import * as Constants from "@/Constants";

interface Insertion {
    advertisingSpace: {
        media: string,
    };
}

@Component({ components: { SimpleText } })
export default class Media extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.advertisingSpace.media",
        ];
    }

    public getLabel(label: string): string {
        const line = _.find(Constants.optionsMedia, (media) => {
            return media.key === label;
        });

        if (!line) {
            return label;
        }
        return _.invoke(
            this.$options.filters,
            "trans",
            line.translationKey
        );
    }

    public classIcon(label: string): string {
        const line = _.find(Constants.optionsMedia, (media) => {
            return media.key === label;
        });

        if (!line) {
            return "minus";
        }
        return line.class;
    }
}
